import React from 'react';
import PropTypes from 'prop-types';
import CTACardv2Styles from './CTACardv2.styled';
import ButtonLink from '../../components/Shared/ButtonLink';
import theme from '../../styles/theme';
import createGTMClass from '../../util/createGTMClass';

const CTACardv2 = ({
  backgroundTop = theme.colors.white,
  backgroundBottom = theme.colors.bedtime,
  headerContent,
  preHeaderContent,
  borders = false,
  backgroundPrimaryColor,
  backgroundSecondaryColor,
  dividerColor,
  gtmClassName,
  buttonText,
  buttonUrl,
  ctaIntro,
  buttonLinkExternal = false,
}) => {
  return (
    <CTACardv2Styles
      backgroundPrimaryColor={backgroundPrimaryColor}
      backgroundSecondaryColor={backgroundSecondaryColor}
      backgroundTop={backgroundTop}
      backgroundBottom={backgroundBottom}
      dividerColor={dividerColor}
      borders={borders}
    >
      <div className='inner'>
        <div className='skewed-primary'>
          <div className='primary'>
            {preHeaderContent && (
              <p className='type-label-large'>{preHeaderContent}</p>
            )}
            {headerContent && <h2 className='type-h1'>{headerContent}</h2>}
          </div>
        </div>
        <div className='skewed-secondary'>
          <div className='secondary'>
            {buttonText && buttonUrl && (
              <div className='links'>
                <ButtonLink
                  title={buttonText}
                  to={buttonUrl}
                  size={'large'}
                  className={createGTMClass(gtmClassName, 'cta', 'button')}
                  hoverAppearance={'dark'}
                  isExternal={buttonLinkExternal}
                >
                  {buttonText}
                </ButtonLink>
              </div>
            )}
            <p className='cta-intro'>{ctaIntro}</p>
          </div>
        </div>
      </div>
    </CTACardv2Styles>
  );
};

CTACardv2.propTypes = {
  ctaIntro: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  backgroundTop: PropTypes.string,
  backgroundBottom: PropTypes.string,
  headerContent: PropTypes.string,
  preHeaderContent: PropTypes.string,
  borders: PropTypes.bool,
  backgroundPrimaryColor: PropTypes.string,
  backgroundSecondaryColor: PropTypes.string,
  dividerColor: PropTypes.string,
  gtmClassName: PropTypes.string,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  ctaIntro: PropTypes.string,
  buttonLinkExternal: PropTypes.bool,
};

export default CTACardv2;
